export class DisplayEntity {
  // TODO make read onlyu
  displayName: string;
  entityId: string;
  entityType: string;
  // 003-retire-ngrx: always written by the loginSuccess transition, but only as
  // an expando on an untyped local in the old reducer — declared properly now
  // that the transition lives in SecurityService (typed).
  entityName: string;
}
